
class HomeFeature extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.init();
  }
  init() {
    this.setup();
  }
  setup() {
    new MasterTimeline({
      triggerInit: this,
      scrollTrigger: { trigger: this.querySelector('.home-feature-title') },
      tweenArr: [
        new RevealTextReset({ el: this.querySelector('.home-feature-title .txt'), color: 'black' })
      ]
    })

    new MasterTimeline({
      triggerInit: this,
      scrollTrigger: { trigger: this.querySelector('.home-feature-key-list-inner'), start: 'top 60%' },
      tweenArr: [
        new ScaleLine({ el: this.querySelector('.home-feature-key-list .div-line'), isCenter: true}),
        ...Array.from(this.querySelectorAll('.home-feature-key-item')).flatMap((item, index) => {
          const lineTop = item.querySelector('.div-line');
          const img = item.querySelector('.home-feature-key-item-img');
          const title = item.querySelector('.home-feature-key-item-title .txt');
          const decs = item.querySelector('.home-feature-key-item-sub .txt');
          const btn = item.querySelector('.home-feature-key-item-btn');
          return [
            new ScaleLine({ el: lineTop, type: 'top' }),
            new FadeIn({ el: img, delay: (index + 1) * 0.15 }),
            new FadeSplitText({ el: title , delay: (index + 1) * 0.3 }),
            new FadeSplitText({ el: decs,  delay: (index + 1) * 0.45}),
            new FadeIn({ el: btn,  delay: (index + 1) * 0.6 })
          ]
        })
      ]
    })
  }
}

customElements.define('home-feature', HomeFeature);